module.exports = __webpack_public_path__ + "static/media/olovnePlombe2.d2dc3fb6.JPG";